import React, { useEffect } from "react";

const ChatAcquire = () => {
    useEffect(() => {
        const script    = document.createElement('script');

        script.src      = "https://s.acquire.io/a-d5b89/init.js?full";
        script.async    = true;

        document.body.appendChild(script);
    }, []);
    

    return (<></>);
};

export default ChatAcquire;